module.exports = __webpack_public_path__ + "static/Product-Online-Fullframe-2.22a2d18d.jpg";